import { isNud } from '@/shared/utilities/typing'
import Category from '@/shared/models/entities/kumiiro/category';

/**
 * アニコマ作品 エンティティ
 */
class Theme {
    theme_id;
    theme_name;
    priority;
    category;
    is_published;
    svg;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.theme_id = properties.theme_id;
        this.theme_name = properties.theme_name;
        this.priority = properties.priority;
        this.category = new Category(properties.category);
        this.is_published = properties.is_published;
        this.svg = properties.svg;
    }
}

export default Theme;
